import { GiftCardStatus } from '../enums/gift-card.enum';

export class GiftCarFromNonce {
  constructor(
    public merchant_id: string = null,
    public nonce: string = null
  ) {
  }
}

export class GiftCard {
  constructor(
    public balance: number = 0,
    public state: GiftCardStatus = null,
  ) {
  }
}

export class CustomerGiftCard {
  constructor(
    public balance_money:{amount:number,currency:string} = {amount:0,currency:'USD'},
    public gan:string=null,
    public type:string=null,
    public id:string=null,
    public state:GiftCardStatus = null,
  ){}

}

export class PartialBalance {
  constructor(
    public giftCard: number = 0,
    public card: number = 0
  ) {
  }
}

export class AppliedGiftCard {
  constructor(
    public sourceId: string = null,
    public balance: number = 0,
    public isNonce: boolean = false,
    public last4: string = ''
  ) {
  }
}

export class GiftCardOrderDTO {
  constructor(
    public id: number = null,
    public sendDate: string = '',
    public recipientPhoneNumber: string = '',
    public recipientEmail: string = '',
    public firstName: string = '',
    public lastName: string = '',
    public orderBotUserId: string = '',
    public merchantId: string = '',
    public amount: number = 0,
    public message: string = '',
    public imageUrl: string = '',
    public status: string = 'CREATED',
    public transactionId: string = '',
    public pickupType: string = '',
    public squareGiftCardId: string = '',
    public senderName: string = ''
  ) {}
}

export class GiftCardActivityDTO {
  constructor(
    public gan: string = '',
    public transactionId: string = ''
  ) {}
}

export class Recipient {
  constructor(
    public firstName: string = '',
    public lastName: string = '',
    public phoneNumber: string = '',
    public email: string = '',
    public message: string = '',
    public sendDate: string = null,
    public pickupType: string = ''
  ) {}
}

export class GiftCardReload {
  constructor(
    public id: string = null,
    public type: string = null,
    public balance_money: { amount: number; currency: string } = { amount: 0, currency: 'USD' },
    public gan: string = null,
    public enable_auto_reload: boolean = false,
    public auto_reload_threshold: number = 0,
    public auto_reload_location_id: string = null,
    public auto_reload_amount: number = 0,
    public auto_reload_source_id: string = null
  ) {}
}

export class GiftCardReloadDTO {
  constructor(
    public id: string = null,
    public auto_reload_threshold: number = 0,
    public auto_reload_location_id: string = null,
    public auto_reload_amount: number = 0,
    public auto_reload_source_id: string = null,
    public isDelete:boolean = false
  ) {}
}

